export default __webpack_public_path__ + "static/media/genom-ready.e9e721a6.png";